import { SympyBuildError } from "./shared";
import { SympyBuilder } from "./SympyBuilder";

import type { SemanticExpr } from "../types";
import type { NodeJson } from "@corca/data";

/** Throws SympyBuildError for input it cannot translate; the host decides how to report that. */
export function nodeToSemantic(
  node: NodeJson,
  existingVariables?: Map<string, string>,
  emitSiUnitsOverride?: boolean | null,
): {
  expr: SemanticExpr;
  variables: Map<string, string>;
  symbolNodes: Map<string, NodeJson>;
  indexedBases: Set<string>;
  warnings: string[];
} {
  const builder = new SympyBuilder(node, existingVariables, emitSiUnitsOverride);
  const expr = builder.build(node);
  if (expr === null) throw new SympyBuildError("Expression is empty");

  return {
    expr,
    variables: builder.variables,
    symbolNodes: builder.symbolNodes,
    indexedBases: builder.indexedBaseNames,
    warnings: builder.warnings,
  };
}
